import { ComponentProps, type ElementType } from 'react';
import { type ControllerRenderProps, type FieldValues } from 'react-hook-form';

import { useControlledField } from './ControlledFieldContext';
import FormInput from '../FormInput';

interface ControlledFieldBaseProps {
  status?: 'default' | 'error' | 'warning' | 'success' | 'info';
}

type FieldProps = ControllerRenderProps<FieldValues, string>;

type ControlledFieldControlProps<C extends React.ElementType> = Omit<
  PolymorphicComponentProp<C, ControlledFieldBaseProps>,
  Exclude<keyof FieldProps, 'disabled'>
> & {
  onChange?: ComponentProps<C>['onChange'];
};

const ControlledFieldControl = <C extends ElementType = typeof FormInput>({
  as,
  onChange,
  ...props
}: ControlledFieldControlProps<C>) => {
  const { field, fieldState } = useControlledField();
  const Component = (as || FormInput) as ElementType;

  return (
    <Component
      {...props}
      {...field}
      onChange={(...args) => {
        onChange?.(...args);
        field.onChange(...args);
      }}
      status={fieldState.error ? 'error' : 'default'}
    />
  );
};

export default ControlledFieldControl;
